module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title"
    }],
    attrs: {
      "data-title": "首页"
    }
  }, [(_vm.ShowBox) ? _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh",
      "background": "rgba(0, 0, 0, 0.8)",
      "position": "fixed",
      "z-index": "99999"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../../static/degree/bg_01.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "30%",
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "left loaction"
  }, [_c('span', {
    staticStyle: {
      "color": "#fff",
      "font-size": "0.28rem"
    }
  }, [_vm._v("[")]), _c('a', {
    ref: "citySelected",
    staticClass: "hover",
    on: {
      "click": _vm.showCity
    }
  }, [_vm._v(_vm._s(_vm.chosedCity.split("?")[0]))]), _c('span', {
    staticStyle: {
      "color": "#fff",
      "font-size": "0.28rem",
      "display": "inline-block"
    }
  }, [_vm._v("]")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "40%",
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.6rem",
      "display": "block"
    },
    attrs: {
      "src": _vm.headerLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%",
      "align": "right"
    }
  }, [_c('img', {
    staticClass: "ewm",
    attrs: {
      "src": "/static/images/sys.png",
      "alt": "安徽继续教育网"
    },
    on: {
      "click": _vm.showEwm
    }
  })]), _vm._v("\n        =\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "area_select_box"
  }, [_c('div', {
    staticClass: "trangle_box"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('p', {
    attrs: {
      "name": "34"
    },
    on: {
      "click": _vm.chooseCity
    }
  }, [_vm._v("安徽")])]), _vm._v(" "), _vm._l((_vm.adressData), function(msg) {
    return _c('li', [_c('p', {
      attrs: {
        "name": msg.codeid
      },
      on: {
        "click": _vm.chooseCity
      }
    }, [_vm._v(_vm._s(msg.cityname))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "pool_box",
    on: {
      "click": _vm.hideCity
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ewm_pool",
    on: {
      "click": _vm.hideEwm
    }
  }, [_c('div', {
    staticClass: "ewm_box"
  }, [_c('p', [_vm._v("扫一扫加关注")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.headerEwm,
      "alt": "安徽继续教育网"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.9rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticStyle: {
      "height": "0.05rem",
      "background": "#eee"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab_nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/chooseClass"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/1_27.png",
      "alt": "安徽继续教育网"
    }
  }), _vm._v(" "), _c('p', [_vm._v("报名选课")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/myClass"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/1_29.png",
      "alt": "安徽继续教育网"
    }
  }), _vm._v(" "), _c('p', [_vm._v("学习中心")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/zscy"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/1_33.png",
      "alt": "安徽继续教育网"
    }
  }), _vm._v(" "), _c('p', [_vm._v("证书查验")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paperList"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/1_34.png",
      "alt": "安徽继续教育网"
    }
  }), _vm._v(" "), _c('p', [_vm._v("模拟练习")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "type_box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeData1.list != null),
      expression: "typeData1.list != null"
    }],
    staticClass: "type_list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "k_detail"
  }, [_c('ul', _vm._l((_vm.typeData1.list), function(msg) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/chooseClass',
          query: {
            codeNo: msg.codeNo
          }
        }
      }
    }, [_vm._v(_vm._s(msg.codeName))])], 1)
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeData2 != null),
      expression: "typeData2 != null"
    }],
    staticClass: "type_list"
  }, [_c('div', {
    staticClass: "k_top"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/chooseClass"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#75b9d5"
    }
  }, [_vm._v("更多>>")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "k_detail"
  }, [_c('ul', _vm._l((_vm.typeData2.list), function(msg) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/chooseClass',
          query: {
            codeNo: msg.codeNo
          }
        }
      }
    }, [_vm._v(_vm._s(msg.codeName))])], 1)
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeData3 != null),
      expression: "typeData3 != null"
    }],
    staticClass: "type_list"
  }, [_c('div', {
    staticClass: "k_top"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/chooseClass"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#75b9d5"
    }
  }, [_vm._v("更多>>")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "k_detail"
  }, [_c('ul', _vm._l((_vm.typeData3.list), function(msg) {
    return _c('li', [_c('router-link', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "to": {
          path: '/chooseClass',
          query: {
            codeNo: msg.codeNo
          }
        }
      }
    }, [_vm._v(_vm._s(msg.codeName))])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "advertise"
  }, [_c('mt-swipe', {
    staticStyle: {
      "height": "2.1rem"
    },
    attrs: {
      "auto": 4000
    }
  }, _vm._l((_vm.imagesData), function(item, idx) {
    return _c('mt-swipe-item', {
      key: item.id,
      class: _vm.slide + (idx + 1)
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/carouselFigureDetail',
          query: {
            picId: item.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.picUrl,
        "alt": "安徽继续教育网"
      }
    })])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tzgg"
  }, [_c('div', {
    staticClass: "new_top"
  }, [_vm._m(3), _vm._v(" "), _c('router-link', {
    staticClass: "new_more right",
    attrs: {
      "to": {
        path: '/notify',
        query: {
          codeNo: '150104'
        }
      }
    }
  }, [_vm._v("更多>>")])], 1), _vm._v(" "), _c('div', {
    staticClass: "new_main"
  }, [_c('ul', _vm._l((_vm.newsData.list), function(msg) {
    return _c('li', [_c('router-link', {
      staticClass: "left",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "to": {
          path: '/notifyDetail',
          query: {
            codeNo: '150104',
            name: msg.name
          },
        }
      }
    }, [_c('table', [_c('tr', [_c('td', {
      attrs: {
        "width": "3%"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/222_03.png",
        "width": "7",
        "alt": "安徽继续教育网"
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "97%"
      }
    }, [_c('p', {
      staticClass: "news_titles"
    }, [_vm._v(_vm._s(msg.title))])])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "xwzx"
  }, [_c('div', {
    staticClass: "new_top"
  }, [_vm._m(4), _vm._v(" "), _c('router-link', {
    staticClass: "new_more right",
    attrs: {
      "to": {
        path: '/notify',
        query: {
          codeNo: '150101'
        }
      }
    }
  }, [_vm._v("更多>>")])], 1), _vm._v(" "), _c('div', {
    staticClass: "new_main"
  }, [_c('ul', _vm._l((_vm.newsData2.list), function(msg) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/notifyDetail',
          query: {
            codeNo: '150101',
            name: msg.name
          },
        }
      }
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "3%"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/222_03.png",
        "alt": "安徽继续教育网",
        "width": "7"
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "97%"
      }
    }, [_c('p', {
      staticClass: "news_titles"
    }, [_vm._v(_vm._s(msg.title))])])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])], 1)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "back_to_top",
    on: {
      "click": _vm.backToTop
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/backtotop.png",
      "alt": "安徽继续教育网"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer1"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('li', {
    staticClass: "line3"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("注册")])], 1)])]), _vm._v(" "), _c('footCommon')], 1), _vm._v(" "), _c('navBottom'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowIndexAlert),
      expression: "isShowIndexAlert"
    }],
    staticClass: "alert_close_class_box"
  }, [_c('div', {
    staticClass: "alert_close_class"
  }, [_c('img', {
    staticClass: "alert_close_class_close",
    attrs: {
      "src": "/static/images/alert_warn_02.png",
      "alt": "安徽继续教育网"
    },
    on: {
      "click": _vm.closeAlertClass
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/carouselFigureDetail?picId=' + _vm.indexAlertMsg.picId
    }
  }, [_c('img', {
    staticClass: "alert_close_class_img",
    attrs: {
      "src": _vm.indexAlertMsg.picUrl,
      "alt": "安徽继续教育网"
    }
  })])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "k_top gxk_top"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "k_title k_gx"
  }, [_vm._v("继续教育公需课")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "60%",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "k_title k_zy"
  }, [_vm._v("继续教育专业课")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "width": "60%",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "k_title k_zg"
  }, [_vm._v("转岗培训")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "news_title"
  }, [_vm._v("通知公告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "news_title"
  }, [_vm._v("行业资讯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b7a1479"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 854
// module chunks = 8